<template>
  <div>
  <!--   <v-app-bar
      app
      color="appMenu"
      dense
      class="fill-height"
      dark
      clipped-right
      height="32"
      fixed
    >
      <v-icon left> mdi-calendar-text</v-icon>{{ $t("menu.agenda") }}
      <v-spacer></v-spacer>
    </v-app-bar> -->
      <AgendaSettings                     
      ></AgendaSettings>
      <ConfirmDialog ref="confirm" />
  </div>
</template>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
// @ is an alias to /src
import AgendaSettings from "@/components/agenda/AgendaSettings.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import Vue from "vue";
Vue.prototype.$eventHub = new Vue();
export default {
  name: "Agenda",
  data() {
    return {
    };
  },
 
  components: {
    AgendaSettings,   
    ConfirmDialog,
  },
  computed:{
   
  },
  async beforeRouteLeave(to, from, next) {
    //const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (false) {
      const answer = await this.ConfirmDelete();
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    async ConfirmDelete() {
      if (
        await this.$refs.confirm.open(
          this.$t("hUnsavedDataConfirmation"),
          this.$t("lblUnsavedDataMessage")
        )
      ) {
        return true;
      }
    },

  },
};
</script>
